module.exports = __webpack_public_path__ + "location-menu.png";